export interface UiOwnershipNote {
  packageName: '@tov-plus/ui';
  purpose: 'shared_primitives';
}

export interface DesignTokenContract {
  tokenGroup: string;
  tokenKeys: string[];
}

export interface SurfaceThemeContract {
  mode: 'planner' | 'guest' | 'vendor' | 'admin' | 'marketing' | 'docs';
  accent: string;
  accentStrong: string;
}

export interface ComponentLibraryContract {
  componentId: string;
  classNames: string[];
}

export const PageStatus = {
  IDLE: 'idle',
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error',
} as const;

export type PageStatus = (typeof PageStatus)[keyof typeof PageStatus];
